import React from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import notify from "../components/common/notify";
import { handleError } from "../hooks/useApi";
import {
  useAcceptProjectInvitationMutation,
  useGetProjectByIdQuery,
} from "../redux/slices/api/projectsApiSlice";
import { Bars } from "react-loader-spinner";
import { accessToken, role } from "../utils/localData";
import { UN_REGISTERED } from "../Constants";
import {
  setRegisterModalType,
  setShowRegisterModal,
  setRedirectUrl,
  selectGeneral,
  setShowAuthModal,
} from "../redux/slices/generalSlice";
import { useDispatch, useSelector } from "react-redux";
import MetaTags from "../components/common/MetaTags";
const VerifyEmail = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  // Extract necessary parameters from the URL
  let token = searchParams.get("token");
  let project_id = searchParams.get("project_id");
  let registered = searchParams.get("registered");

  // Use the accept project invitation mutation
  const [acceptInvitationProject, { isLoading }] =
    useAcceptProjectInvitationMutation();

  // Function to check if the user is authorized
  const isAuthorized = () => {
    if (accessToken() && role() !== UN_REGISTERED) return true;
    return false;
  };

  // Use the get project by ID query
  const {
    isLoading: projectLoading,
    data,
    error: getProjectError,
  } = useGetProjectByIdQuery({
    id: project_id,
    ...(!isAuthorized() && { token }),
  });

  const { isLoggedIn } = useSelector(selectGeneral);
  const { project } = data ?? {};
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  // Function to handle accepting the invitation
  const handleAcceptInvitation = async () => {
    // If there's a token
    if (token) {
      // Require auth - will show auth modal if not logged in
      if (!isLoggedIn || !accessToken()) {
        dispatch(setRedirectUrl(pathname + search));
        dispatch(setShowAuthModal({ show: true, redirect: pathname + search }));
        return;
      }
      
      // If the user is unregistered, show the register modal
      if (role() === UN_REGISTERED) {
        dispatch(setRegisterModalType("signupBtn"));
        dispatch(setRedirectUrl(pathname + search));
        dispatch(setShowRegisterModal(true));
        return;
      }
      // If the user is logged in and registered, accept the invitation
      try {
        const res = await acceptInvitationProject({
          body: { token },
        }).unwrap();
        notify(res?.message, "success");
        navigate(`/projects/${project_id}`);
      } catch (error) {
        handleError(error, null, true);
      }
    }
    // If there's no token, show an error
    else {
      notify("invalidate token!", "error");
    }
  };
  if (projectLoading) {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Bars
          height="50"
          width="50"
          color="#8538ff"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    );
  } else
    return (
      <div className="w-full h-screen flex flex-col justify-center items-center text-center">
        <MetaTags
          title="Accept Invitation"
          description={`NFT- Fundraising By FunDeSci An innovative approach for decentralized crowdfunding of scientific projects`}
          link="/accept-invitation"
          noIndex
        />
        {getProjectError ? (
          <div className="text-xl font-bold">
            {getProjectError?.data?.message}
          </div>
        ) : (
          <div>
            <p className="text-xl">
              You invited to{" "}
              <Link
                target="_blank"
                to={`/projects/${project_id}`}
                className="font-bold text-blue-link"
              >
                {" "}
                {project?.title}
              </Link>
              <br />
              If you want to accept the invitation click the button below
              <br />
              and If you want to see project details click on View Project
              button
            </p>
            <div className="w-full flex justify-center items-center mt-10">
              <Link
                to={
                  isAuthorized()
                    ? `/projects/${project_id}`
                    : `/projects/${project_id}?token=${token}`
                }
                target="_blank"
                className="w-48 h-10 mr-5 text-custom-gray-700 border border-custom-gray-700 flex justify-center items-center  rounded-[10px] hover:bg-custom-gray-700 hover:text-white transition-all duration-300"
              >
                View Project
              </Link>
              <button
                onClick={handleAcceptInvitation}
                disabled={isLoading}
                className={`w-[12.5rem] h-10 bg-light-primary flex justify-center items-center text-white text-sm  rounded-lg disabled:cursor-not-allowed disabled:opacity-70 ${
                  isLoading ? "animate-pulse red-gradient" : "bg-light-primary"
                }`}
              >
                {isLoading ? "Accepting" : "Accept"}
              </button>
            </div>
          </div>
        )}
      </div>
    );
};

export default VerifyEmail;
